// src/data/personalInfo.js
export const personalInfo = {
  name: "Arunav Saha",
  title: "Computer Science Student",
  location: "Memorial University of Newfoundland",
  email: "arunavsaha814@gmail.com",
  github: "https://github.com/ARNAB814",
  linkedin: "https://www.linkedin.com/in/arunavsaha",
  about:
    "Computer Science graduate passionate about app development and full-stack web development. Recently completed my Bachelor of Science (Hons.) in Computer Science.",
  resume: "https://github.com/ARNAB814/Resume/blob/main/Resume.pdf",
};

export const heroData = {
  headline: "Welcome to my website!",
  subheading:
    "Hey there! I'm Arunav Saha, recently graduated with a Bachelor of Science (Hons.) in Computer Science from Memorial University of Newfoundland. Thank you for visiting my portfolio!",
  techStack: [
    "Python",
    "JavaScript",
    "React",
    "Node.js",
    "Java",
    "C++",
    "Astro",
  ],
};

// Site configuration
export const siteConfig = {
  navLinks: [
    { id: "home", label: "Home" },
    { id: "work", label: "Work Experience" },
    { id: "courses", label: "Courses" },
    { id: "projects", label: "Projects" },
    { id: "gallery", label: "Gallery" },
  ],
  defaultTheme: "dark", // 'light', 'dark', or 'system'
  themeColor: "#3B82F6", // Primary brand color
  accentColor: "#8B5CF6", // Secondary accent color
  contactEmail: "arunavsaha814@gmail.com",
};